import { InjectionToken } from '@angular/core';

export const ASSETS = new InjectionToken('ASSETS');
